import {
  DragCancelEvent,
  DragEndEvent,
  DragOverEvent,
  DragStartEvent,
} from "@dnd-kit/core";
import { calculateValidity, calculateZoneValidity } from "./utils";

const announcements = {
  onDragStart: (event: DragStartEvent) => {
    let message = "";
    const { active } = event;
    message = `Dragging ${active.data.current?.label}.`;
    return message;
  },
  onDragOver: (event: DragOverEvent) => {
    const { active, over } = event;
    let message = "";
    let valid = true;

    if (active.id === over?.id) {
      message = `Dragging ${active.data.current?.label}.`;
    }
    // Check if the over item is a zone
    else if (over?.data.current?.isZone) {
      message = `Dragging ${active.data.current?.label} over ${over?.data.current?.label}.`;
      valid = calculateZoneValidity({
        active,
        zone: over,
      });
      // Check if the over item is another item
    } else {
      if (!over?.data.current?.zone) {
        message = `Dragging ${active.data.current?.label} over ${over?.data.current?.label} outside of any drop zone.`;
      } else {
        valid = calculateValidity({
          active,
          acceptedTypes: over?.data.current?.zone?.acceptedTypes,
          validator: over?.data.current?.zone?.validator,
        });
        // Check if the over item is in a sortable zone
        if (over.data.current.zone.sortable) {
          message = `Dragging ${active.data.current?.label} over ${over?.data.current?.label} within ${over?.data.current?.zone.label}.`;
        }
        // Item is in a non-sortable zone
        else {
          message = `Dragging ${active.data.current?.label} over ${over?.data.current?.zone.label}.`;
        }
      }
    }
    if (!valid) message += ` This is an invalid zone.`;
    return message;
  },
  onDragEnd: (event: DragEndEvent) => {
    let message = "";
    let valid = true;
    const { active, over } = event;

    if (active.id === over?.id) {
      message = `Dropped ${active.data.current?.label} in the same position.`;
    }
    // Check if the over item is a zone
    else if (over?.data.current?.isZone) {
      valid = calculateZoneValidity({
        active,
        zone: over,
      });
      if (over?.data.current?.sortable) {
        if (over.id === active.data.current?.zone?.id) {
          message = `Dropped ${active.data.current?.label} in the same position.`;
        } else {
          message = `Dropped ${active.data.current?.label} at the ${over.data.current.defaultDropPosition} of ${over?.data.current?.label}.`;
        }
      } else {
        message = `Dropped ${active.data.current?.label} into ${over?.data.current?.label}.`;
      }
    } else {
      // Check if the over item is not in a zone
      if (!over?.data.current?.zone) {
        message = `Dropped ${active.data.current?.label} into ${over?.data.current?.label} outside of any drop zone.`;
      } else {
        valid = calculateValidity({
          active,
          acceptedTypes: over?.data.current?.zone?.acceptedTypes,
          validator: over?.data.current?.zone?.validator,
        });
        // Check if the over item is in a sortable zone
        if (over.data.current.zone.sortable) {
          message = `Dropped ${active.data.current?.label} onto ${over?.data.current?.label} within ${over?.data.current?.zone.label}.`;
        }
        // Item is in a non-sortable zone
        else {
          message = `Dropped ${active.data.current?.label} into ${over?.data.current?.zone.label}.`;
        }
      }
    }
    if (!valid) message += ` This was an invalid zone.`;
    return message;
  },
  onDragCancel: (event: DragCancelEvent) => {
    const { active } = event;
    return `Cancelled dragging ${active.data.current?.label}.`;
  },
};

export default announcements;
